/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Badge, Layout } from 'antd';
import Logo from 'components/Logo';
import UserInfo from 'components/UserInfo';
import breakpoints from 'constants/breakpoints';
import { THEME_TYPE_DARK, THEME_TYPE_SEMI_DARK } from 'constants/ThemeSetting';
import useWindowSize from 'hooks/useWindowSize';
import React, { CSSProperties } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import SelectedAppointmentContactAction from 'redux/selected-contact/selected-contact.action';
import SelectedAppointmentContactSelectors from 'redux/selected-contact/selected-contact.selectors';
import { RootState } from 'redux/types';

import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from '../../constants/ThemeSetting';
import SettingsAction from '../../redux/settings/settings.actions';
import UserNotifications from './UserNotifications';

const { toggleCollapsedSideNav } = SettingsAction;

const { Header } = Layout;

const Topbar: React.FC = () => {
  const { navStyle } = useSelector<RootState, RootState['settings']>(({ settings }) => settings);
  const { navCollapsed, width } = useSelector<RootState, RootState['common']>(({ common }) => common);
  const isDark = useSelector((state: RootState) => state.settings.themeType === THEME_TYPE_DARK);
  const dispatch = useDispatch();
  const { totalUnreadMessages } = useSelector(SelectedAppointmentContactSelectors.selectAppointmentContact);

  // const languageMenu = () => (
  //   <CustomScrollbars className='gx-popover-lang-scroll'>
  //     <ul className='gx-sub-popover'>
  //       {languageData.map((language) => (
  //         <li
  //           className='gx-media gx-pointer'
  //           key={JSON.stringify(language)}
  //           onClick={(e) => dispatch(switchLanguage(language))}>
  //           <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
  //           <span className='gx-language-text'>{language.name}</span>
  //         </li>
  //       ))}
  //     </ul>
  //   </CustomScrollbars>
  // );

  // const updateSearchChatUser = (evt: BaseSyntheticEvent) => {
  //   setSearchText(evt.target.value);
  // };

  const onToggleDarkTheme = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(SettingsAction.setThemeType(e.target.checked ? THEME_TYPE_DARK : THEME_TYPE_SEMI_DARK));
  };

  const onChatClick = () => {
    dispatch(SelectedAppointmentContactAction.setSelectedAppointmentContact({ active: true }));
  };

  const { isMobile } = useWindowSize(parseFloat(breakpoints.sm));

  const headerContainerStyleInMobile: CSSProperties = isMobile ? { height: 50, position: 'relative' } : {};
  const headerStyleInMobile: CSSProperties = isMobile ? { position: 'fixed', left: 0, top: 0, width: '100%' } : {};

  return (
    <div style={headerContainerStyleInMobile}>
      <Header style={headerStyleInMobile}>
        {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ? (
          <div className='gx-linebar gx-mr-2'>
            <button
              className='gx-header-icon-btn-wrapper'
              type='button'
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}>
              <i className='gx-icon-btn icon icon-menu' />
            </button>
          </div>
        ) : null}
        <Link to='/' className='gx-d-block gx-d-lg-none gx-pointer'>
          <Logo />
        </Link>
        {/* 
      <SearchBox
        styleName='gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg'
        placeholder='Search in app...'
        onChange={updateSearchChatUser}
        value={searchText}
      /> */}
        <ul className='gx-header-notifications gx-ml-auto'>
          <li className='theme-toggle-wrapper'>
            <>
              <input type='checkbox' id='theme-toggle' checked={isDark} onChange={onToggleDarkTheme} />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor='theme-toggle'>
                <span />
                <img src={require('../../assets/images/sunny.svg')} alt='sun-icon' />
              </label>
            </>
          </li>
          <li className='chat-icon-header gx-notify'>
            <div className='gx-pt-2' onClick={onChatClick}>
              <Badge count={totalUnreadMessages} size='small'>
                <span className='gx-pointer gx-d-block'>
                  <i style={{ fontSize: '20px' }} className='icon icon-chat' />
                </span>
              </Badge>
            </div>
          </li>
          <UserNotifications />
          {width >= TAB_SIZE ? null : (
            <>
              <li className='gx-user-nav'>
                <UserInfo />
              </li>
            </>
          )}
        </ul>
      </Header>
    </div>
  );
};

export default Topbar;
